import React from 'react';
import classNames from 'classnames/bind';
import { Rating } from 'react-simple-star-rating';
import { useHistory } from 'react-router-dom';
import { IonCard, IonItem } from '@ionic/react';
import { ReviewType } from '../../../generated/graphql';
import styles from './DoctorReview.module.scss';

const cx = classNames.bind(styles);

interface IDoctorReview {
  review: ReviewType;
}

const DoctorReview = ({ review }: IDoctorReview) => {
  const { push } = useHistory();

  return (
    <IonCard onClick={() => push(`../review/${review.id}`)} className={cx(styles.ionCard)} mode="ios">
      <IonItem className={cx(styles.item)}>{`Name : ${review.author.firstName} ${review.author.secondName}`}</IonItem>
      <IonItem className={cx(styles.item)}>
        <Rating fillColor="var(--ion-color-primary)" allowFraction readonly initialValue={review.averageEntryStars} />
      </IonItem>
      <IonItem className={cx(styles.item)}>{`Comment : ${review.comment}`}</IonItem>
    </IonCard>
  );
};

export { DoctorReview };
